import React from 'react';
import LinkButton from '../../platformui/Buttons/LinkButton';
import useWindowLocationHref from '../../platformui/Hooks/useWindowLocation';

const FocusBlock = ({
  heading,
  description,
  informationType,
  link,
  linkText,
  isFullWidth,
}) => {
  const href = useWindowLocationHref();
  const getTypeText = (text) => {
    const textMap = {
      article: 'Artikel',
      story: 'Egna berättelser',
      facts: 'Fakta',
      faq: 'Fråga UMO',
      shortstory: 'Sexnoveller',
      support: 'Stödställen',
      forum: 'Svara varandra',
      tip: 'Tips/inlägg från unga',
      podcast: 'UMO-podden',
      other: 'Övrigt',
    };
    return textMap[text];
  };

  return isFullWidth ? (
    <div className={`c-focus-block theme--${informationType} full-width`}>
      <div className="c-focus-block__inner">
        <div>
          <div className="c-focus-block__informationType">
            <div className="icon"></div>
            <span>{getTypeText(informationType)}</span>
          </div>
          <h2>{heading}</h2>
          <p>{description}</p>
          <LinkButton
            link={link}
            linkText={linkText}
            buttonClass="c-focus-block__button"
          />
        </div>
        <div className="c-focus-block__icon"></div>
      </div>
    </div>
  ) : (
    <div className={`c-focus-block theme--${informationType}`}>
      <div className="c-focus-block__inner">
        <div>
          <div className="c-focus-block__informationType">
            <span>{getTypeText(informationType)}</span>
          </div>
          {link ? (
            <a
              data-event-category={href || 'novalue'}
              data-event-action={getTypeText(informationType)}
              data-event-name="Fokuspuff"
              href={link}
              className="c-focus-block__link"
            >
              <h2 data-event-include>{heading}</h2>
            </a>
          ) : (
            <h2 data-event-include>{heading}</h2>
          )}
        </div>
        <div className="c-focus-block__icon"></div>
      </div>
    </div>
  );
};

export default FocusBlock;
